<template>
    <div class="policy-custom-form">
        <!-- Item (Joe, 2026-08-12): removed the redundant "Start from a template" picker.
             The top "How do you want to create this BAA?" choice already distinguishes
             using a template ("Medcurity or saved template") from writing your own, so a
             second template picker on the custom path was confusing. Custom = write your
             own; to use a template, pick that option up top. -->
        <div class="row">
            <div class="form-group col-12 col-md-8">
                <label for="name">BAA title</label>
                <input class="form-control" type="text" name="name" id="name" v-model="inputs.name" placeholder="e.g. BAA for Acme Billing Services" />
                <small class="form-text text-muted">Shown on the agreement. Tip: include the business associate&rsquo;s company name.</small>
            </div>
        </div>

        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="renewal_frequency">Review Frequency</label>
                <select class="form-control w-100" name="renewal_frequency" id="renewal_frequency" v-model="inputs.renewal_frequency">
                    <option value="" hidden disabled selected>Select Review Frequency</option>
                    <option v-for="(renewFrequencyLabel, renewFrequency) in renewFrequencies" :value="renewFrequency">{{ renewFrequencyLabel }}</option>
                </select>
            </div>
        </div>
        <div class="row" v-if="Object.keys(previousBaas).length">
            <div class="form-group col-12 col-md-6">
                <label for="renewal_frequency">Previous BAAs</label>
                <select class="form-control w-100" name="selected_previous_baa" id="selected_previous_baa" v-model="selected_previous_baa">
                    <option v-for="(previousBaaName, previousBaaId) in previousBaas" v-if="previousBaaName.type != 'upload'" :value="previousBaaId">{{ previousBaaName.name }}</option>
                </select>
                <div v-if="selected_previous_baa">
                    <br>
                    <br>
                    <button id="loadvalues" class="btn btn-secondary" @click.prevent="loadPreviousValues">Insert Content From This BAA</button>
                </div>
            </div>
        </div>


        <BaaMedcurityAssociates></BaaMedcurityAssociates>

        <!-- BAA body. Migrated from CKEditor 4 (vue-ckeditor2) to CKEditor 5
             (ClassicEditor), matching the BAA-template + policy editors. The body
             is bound to the Vuex baaForm.inputs.baa via a hidden field (submitted
             with the form) + an editor<->store sync. A live "fill-in fields" panel
             surfaces the merge-field blanks still in the BAA (the policy-builder
             "questions"), tied to the unresolved-merge-field send guard. -->
        <div class="row">
            <div class="form-group col-12">
                <label for="baa" class="font-weight-bold">The BAA agreement</label>
                <input type="hidden" name="baa" :value="inputs.baa">
                <div v-if="!loadedScript" class="text-muted" style="padding:8px 0;">Loading editor&hellip;</div>
                <div ref="baaEditor" id="baa-editor-holder" style="background:#fff;border:1px solid #D8E0EA;border-radius:8px;min-height:360px;"></div>
                <div v-if="mergeFields.length" style="margin-top:12px;background:#F4F7FB;border:1px solid #D8E0EA;border-radius:10px;padding:12px 14px;">
                    <div style="font-weight:700;color:#1A2230;">Fill-in fields still in this BAA ({{ mergeFields.length }})</div>
                    <div style="font-size:12.5px;color:#5a6b80;margin:2px 0 8px;">Replace each blank in the BAA above before sending it for signature.</div>
                    <div style="display:flex;flex-wrap:wrap;gap:6px;">
                        <span v-for="f in mergeFields" :key="f" style="background:#FFF3CD;border:1px solid #F1D592;border-radius:999px;padding:3px 11px;font-size:12px;font-weight:600;color:#8a5a00;">{{ prettyField(f) }}</span>
                    </div>
                </div>
                <div v-else-if="inputs.baa" style="margin-top:12px;color:#15803d;font-size:13px;font-weight:600;">&#10003; No fill-in blanks remaining.</div>
            </div>
        </div>

        <!-- Complete Assessment Modal -->
        <div class="modal fade" id="update-title-modal" tabindex="-1" role="dialog" aria-labelledby="modal-title" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>
                            <h5 class="modal-title" id="modal-title">Update BAA Title</h5>
                            <p style="font-size:11pt;">(We suggest including the BAA recipient's company name.)</p>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <input type="text" value="" name="update-title" id="update-title" style="padding: 3px 10px; width:100%;">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click.prevent="updateTitle">Accept Title</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import BaaMedcurityAssociates from './BaaMedcurityAssociates'
    export default {
        name: "BaaCustomInputs",
        components: {
            BaaMedcurityAssociates
        },
        data: function(){
            return {
                loadedScript: false,
                baaTemplate: '',
                selected_previous_baa: ''
            }
        },
        computed: {
            ...mapState('baaForm',[
                'inputs',
                'routes',
                'medcurityBaas',
                'statuses',
                'selectedBaa',
                'previousBaas',
                'renewFrequencies'
            ]),
            mergeFields(){
                const html = this.inputs.baa || '';
                const re = /%%([a-z0-9_]+)%%/gi;
                const seen = {}, out = [];
                let m;
                while ((m = re.exec(html))) {
                    const k = m[1].toLowerCase();
                    if (!seen[k]) { seen[k] = true; out.push(k); }
                }
                return out;
            }
        },
        watch: {
            'inputs.baa'(val){
                if (this._editor && this._editor.getData() !== (val || '')) {
                    this._editor.setData(val || '');
                }
            }
        },
        mounted(){
            this.populateBaaTemplate()

            this.selectMedcurityBaaNavigation({});
            this.loadCkeditorScript()
        },
        beforeDestroy(){
            if (this._editor) { this._editor.destroy().catch(function(){}); this._editor = null; }
        },
        methods: {
            ...mapMutations('baaForm',[
                'setCustomBaaContent',
                'selectMedcurityBaa',
                'selectMedcurityBaaNavigation',
                'setFieldsMatchedMedcurityBaa'
            ]),
            prettyField(slug){
                return (slug || '').replace(/_/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
            },
            populateBaaTemplate(){
                if(!Object.keys(this.selectedBaa).length){
                    return
                }
                this.baaTemplate = this.selectedBaa.id
            },
            updateTitle(){
                this.inputs.name = $("#update-title").val();
                $('#update-title-modal').modal('hide');
            },
            loadPreviousValues(){
                let _this = this;
                if(this.selected_previous_baa){
                    axios.get(this.routes.base + this.selected_previous_baa + '/json')
                        .then(response => {
                            if(_this.inputs.baa){
                                if(confirm('Choosing a previous BAA will overwrite your current BAA in view.\n\r Would you like to continue?')){
                                    _this.setCustomBaaContent(response.data.baa);
                                    _this.baaTemplate = '';
                                }
                            }else{
                                _this.setCustomBaaContent(response.data.baa);
                                _this.baaTemplate = '';
                            }

                            let approvePolicyModal = $('#update-title-modal');

                            $("#update-title").val(_this.inputs.name);
                            approvePolicyModal.modal('show');
                        });
                }
            },
            changeMaturityBaa(e){
                const elValue = e.target.value,
                    currentSelection = e.target.dataset.currentSelection

                if(this.inputs.title || this.inputs.baa){
                    if(!confirm('Choosing a new BAA template will overwrite your current title and BAA in view.\n\r Would you like to continue?')){
                        this.baaTemplate = currentSelection
                        return false
                    }
                }

                e.target.dataset.currentSelection = elValue
                this.selectMedcurityBaa(elValue)
                this.setFieldsMatchedMedcurityBaa()

            },
            loadCkeditorScript(){
                const _this = this;
                const cssId = 'cke5-classic-css';
                if (!document.getElementById(cssId)) {
                    const link = document.createElement('link');
                    link.id = cssId; link.rel = 'stylesheet';
                    link.href = 'https://cdn.ckeditor.com/ckeditor5/41.4.2/classic/ckeditor.css';
                    document.head.appendChild(link);
                }
                const done = function(){ _this.loadedScript = true; _this.$nextTick(function(){ _this.initEditor(); }); };
                if (window.ClassicEditor) { done(); return; }
                let script = document.getElementById('cke5-classic-js');
                if (script) { script.addEventListener('load', done); return; }
                script = document.createElement('script');
                script.id = 'cke5-classic-js';
                script.src = 'https://cdn.ckeditor.com/ckeditor5/41.4.2/classic/ckeditor.js';
                script.onload = done;
                document.head.appendChild(script);
            },
            initEditor(){
                const _this = this;
                const holder = this.$refs.baaEditor;
                if (!holder || !window.ClassicEditor || this._editor) { return; }
                holder.innerHTML = this.inputs.baa || '';
                window.ClassicEditor.create(holder, {
                    toolbar: ['heading','|','bold','italic','|','bulletedList','numberedList','|','outdent','indent','|','link','blockQuote','insertTable','|','undo','redo']
                }).then(function(editor){
                    _this._editor = editor;
                    editor.model.document.on('change:data', function(){
                        _this.setCustomBaaContent(editor.getData());
                    });
                }).catch(function(e){ console.error(e); });
            }
        }
    }
</script>

<style scoped>

</style>
